import axiosInstance from '@/plugins/axios';

export const actions = {
    async fetchAuthors() {
        try {
            const response = await axiosInstance.get('/api/authors');
            this.authors = response.data.data ?? response.data ?? [];
            return this.authors;
        } catch (error) {
            console.error('Error fetching authors:', error);
            throw error;
        }
    },
};
